<script>
import { Bar, mixins } from "vue-chartjs";
import chartMixin from "./Mixin";
const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp, chartMixin],
};
</script>
